import { breakpoints } from '../common/mixins';
import platform, { OS_TYPES } from './utils/platform';

export const domIds = {
  adsPlayerId: 'hp-adsplayer',
  videoPlayerId: 'hp-videoplayer',
  subtitlesId: 'hp-subtitles',
  aspectRatioContainerId: 'hp-aspectratio',
  videoContainerId: 'hp-videocontainer',
  controlsContainerId: 'hp-controls',
  wrapperId: 'hp-wrapper',
};

export const domClasses = {
  withControls: 'with-controls',
  miniPlayer: 'mini-player',
};

const STYLES = `
#${domIds.wrapperId} {
  background: black;
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  height: 100%;
  overflow: hidden;
  position: relative;
  z-index: 1;
  width: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-size-adjust: 100%;

  /* for partners where parent is using rtl we want to reset the player back to ltr as we don't support rtl natively. */
  direction: ltr;
}
#${domIds.wrapperId}::after {
  content: '';
  width: 100%;
  height: 100%;
  background: #000;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  transform: scale(0,0);
  transition-delay: 300ms;
  transition: 300ms opacity;
}

#${domIds.wrapperId}.${domClasses.miniPlayer} {
  box-shadow: 0px 0px 20px 3px rgba(0, 0, 0, 0.3);
  bottom: 28px;
  height: 225px;
  position: fixed;
  right: 28px;
  width: 400px;
  @media screen and (max-width: ${breakpoints.sm - 1}px) {
    height: 180px;
    width: 320px;
  }
}

#${domIds.wrapperId} * {
  box-sizing: border-box;
}
#${domIds.wrapperId} ::-webkit-media-controls,
#${domIds.wrapperId} ::-moz-media-controls,
#${domIds.wrapperId} ::-ms-media-controls {
  display: none;
}

#${domIds.aspectRatioContainerId} {
  height: 100%;
}

#${domIds.videoContainerId} {
  background: #1F2326 linear-gradient(to bottom, #1F2326 80%, #000 100%);
  height: 100%;
  position: relative;
  width: 100%;
}
#${domIds.videoContainerId}::before: {
  content: '';
  background: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

#${domIds.videoPlayerId}, #${domIds.adsPlayerId} {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 0;
  top: 0;
}

#${domIds.adsPlayerId}:not([src]), #${domIds.adsPlayerId}[src=""]  {
  display: none !important;
}

#${domIds.subtitlesId} {
  bottom: 32px;
  z-index: 1;
  color: white;
  font-family: "Arial Unicode Ms", Arial, Helvetica, Verdana, "PT Sans Caption", sans-serif;
  font-size: ${platform.os === OS_TYPES.IOS || platform.os === OS_TYPES.ANDROID ? '24px' : '32px'};
  margin: 0;
  padding: 0 0.5em;
  position: ${platform.os === OS_TYPES.IOS || platform.os === OS_TYPES.ANDROID ? 'fixed' : 'absolute'};
  text-align: center;
  text-shadow: 0 .05em 12px rgba(0, 0, 0, 0.6);
  width: 100%;
  white-space: pre-wrap;
  transition: bottom 0.3s ease-out;
}
#${domIds.subtitlesId} * {
  font-style: revert;
  font-weight: revert;
}
#${domIds.subtitlesId}.${domClasses.withControls} {
  bottom: 8rem;
}
#${domIds.subtitlesId} > br {
  display: block;
  content: "";
  margin-top: 0;
}
#${domIds.wrapperId}.${domClasses.miniPlayer} #${domIds.subtitlesId} {
  position: absolute;
  font-size: 14px;
}

#${domIds.controlsContainerId} {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}
`;

export function initPlayerContainer(playerContainer) {
  playerContainer.innerHTML = `
    <style>${STYLES}</style>

    <div id="${domIds.wrapperId}">
      <div id="${domIds.aspectRatioContainerId}">
        <div id="${domIds.videoContainerId}">
          <video playsInline id="${domIds.videoPlayerId}"></video>
          <video playsInline id="${domIds.adsPlayerId}"></video>
        </div>
      </div>

      <div id="${domIds.subtitlesId}"></div>

      <div id="${domIds.controlsContainerId}"></div>
    </div>
  `;
}

export function destroyPlayerContainer(playerContainer) {
  playerContainer.innerHTML = '';
}
